import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const NewsPress = () => {
  return (
    <>
      <SEO 
        title="News & Press - Abacies Logiciels"
        description="Stay updated with the latest news, press releases, and announcements from Abacies Logiciels - covering AI innovations, product launches, partnerships, and company milestones."
        keywords="news, press releases, announcements, company news, Abacies news, technology news, press coverage"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              News & Press
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the News & Press page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for News & Press. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default NewsPress;
